import styled from '@emotion/styled'
import Title from '@organisms/Title'

export const StyledTitle = styled(Title)`
  margin: 25px 0 45px;
`
